import { compressImage } from "../services/image";

export default class FeaturedProduct {
  static get toolbox() {
    return {
      title: "Featured amazon product",
      icon: `<i class="fab fa-amazon"></i>`,
    };
  }

  constructor({ data }) {
    if (data) this.data = {
      imgName: data.imgName || null,
      dataUrl: data.dataUrl || null,
      title: data.title || null,
      link: data.link || null,
      description: data.description || null
    };
    this.imageContainer = null;
    this.titleInput = null;
    this.linkInput = null;
    this.descriptionInput = null;
  }

  render() {
    let wrapper = document.createElement("div");
    wrapper.classList.add("proEditorWrapper", 'cdx-block');

    // featured product
    let featuredAmazonProduct = document.createElement("div");
    featuredAmazonProduct.classList.add("featuredAmazonProduct");
    wrapper.appendChild(featuredAmazonProduct);

    // image container
    this.imageContainer = document.createElement("div");
    this.imageContainer.classList.add('imageContainer');
    featuredAmazonProduct.appendChild(this.imageContainer);

    // file input
    let fileInput = document.createElement('input');
    fileInput.type = "file";
    fileInput.hidden = true;
    featuredAmazonProduct.appendChild(fileInput);

    // text fields
    let textFields = document.createElement("div");
    textFields.classList.add('textFields');
    featuredAmazonProduct.appendChild(textFields);

    this.titleInput = document.createElement('input');
    this.titleInput.type = "text";
    this.titleInput.classList.add('cdx-input');
    this.titleInput.setAttribute('placeholder', "Title");
    textFields.appendChild(this.titleInput);

    this.linkInput = document.createElement('input');
    this.linkInput.type = "text";
    this.linkInput.classList.add('cdx-input', 'text-italic');
    this.linkInput.setAttribute('placeholder', "Link");
    textFields.appendChild(this.linkInput);

    this.descriptionInput = document.createElement('textarea');
    this.descriptionInput.classList.add('cdx-input');
    this.descriptionInput.style = "resize: none";
    this.descriptionInput.setAttribute('placeholder', "Description");
    textFields.appendChild(this.descriptionInput);

    // set existing values
    if (this.data.title) this.titleInput.value = this.data.title;
    if (this.data.link) this.linkInput.value = this.data.link;
    if (this.data.description) this.descriptionInput.value = this.data.description;
    if (this.data.dataUrl) this.imageContainer.style.backgroundImage = `url(${this.data.dataUrl})`;
    else this.imageContainer.innerHTML = `<i class="fab fa-amazon"><i>`;

    // handlle events
    wrapper.querySelector('.imageContainer').addEventListener('click', () => wrapper.querySelector('input[type=file]').click());
    fileInput.addEventListener('change', (e) => this._handleFile(e.target.files[0]))
    this.imageContainer.addEventListener('drop', (e) => this._handleFile(e.dataTransfer.files[0]));

    return wrapper;
  }

  _handleFile(file) {
    compressImage(file, null, (name, dataUrl) => {
      this.data = { ...this.data, imgName: name, dataUrl };
      this.imageContainer.style.backgroundImage = `url(${dataUrl})`;
    });
  }

  save(blockContent) {
    this.data = {
      ...this.data,
      title: this.titleInput.value,
      link: this.linkInput.value,
      description: this.descriptionInput.value,
    }
    return this.data;
  }

  static get sanitize() {
    return {
      a: true,
      i: true,
      b: true,
    };
  }
}